import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/Faq/Faq.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/TabHelp/TabHelp.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/app-dir/link.js");
